import angular from 'angular';

// 3rd party deps
import datepickerPopup from 'angular-ui-bootstrap/src/datepickerPopup';
import datepicker from 'angular-ui-bootstrap/src/datepicker';
import timepicker from 'angular-ui-bootstrap/src/timepicker';
import 'bootstrap-ui-datetime-picker';

//import translation from '../../translation';
//import '../../service';

export const moduleName = 'staff.dashboard.components.simplefields';
let module = angular.module(moduleName, [
  datepicker,
  datepickerPopup,
  timepicker,
  'angularMoment',
  'ui.bootstrap.datetimepicker',
  'recaps.services',
]);

export default module;
